import { BreakpointTrackerContext } from '@jutro/layout';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect } from 'react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './AddressDetails.metadata.json5';
import styles from './AddressDetails.module.scss'

function AddressDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { yourHomeVM, updateSubmissionVM, showErrors, findInvalidComponent, onValidate, submissionVM, steps, resetAllCodes } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const ADDRESS_COMPONENT = 'AddressDetails';
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(ADDRESS_COMPONENT);
    const primaryAddress = _.get(submissionVM, 'lobData.homeowners_tfpa.coverables_Ext.yourHome.primaryAddress')
    const resetPaths = [
        'primaryAddress.addressLine1',
        'primaryAddress.city',
        'primaryAddress.postalCode',
    ];

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, ADDRESS_COMPONENT);
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        if (findInvalidComponent) {
            findInvalidComponent(isComponentValid, ADDRESS_COMPONENT);
        }
    }, [findInvalidComponent, isComponentValid])

    const overrideProps = {
        '@field': {
            // apply to all fields
            // showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            readOnly: true
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={yourHomeVM}
            overrideProps={overrideProps}
            showErrors={showErrors}
            onValidationChange={setComponentValidation}
            // onModelChange={updateYourHome}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

// AddressDetails.propTypes = wizardProps;
export default AddressDetails;
